module.exports = __webpack_public_path__ + "img/16800.22dfddd5.jpg";